import firebase from "firebase";
const config = {
    apiKey: "AIzaSyA0h4k7t0y9ljOeahH3ImliIUOpPoFq-50",
    authDomain: "signica-2020.firebaseapp.com",
    databaseURL: "https://signica-2020.firebaseio.com/",
    projectId: "signica-2020",
    storageBucket: "signica-2020.appspot.com",
    messagingSenderId: "614233004066",
    appId: "1:614233004066:web:8d48fa6dad865199a1527b",
    measurementId: "G-0FDRR7B74S",
};
firebase.initializeApp(config);
export default firebase;